import SubLayout from "@/components/SubLayout";
import { Button, Form } from "antd-mobile";
import { useMemo } from "react";
import { CentifyResult } from "./CentifyResult";
import { CentifySteps } from "./CentifySteps";
import { FaceVideo } from "./FaceVideo";
import { IdCardForm } from "./IdCardForm";
import styles from "./index.module.scss";
import { useLogic } from "./logic";

export function PageCentify() {
  const logic = useLogic();
  const submitText = useMemo(() => {
    switch (`${logic.step}`) {
      case "0":
        return "下一步";
      case "1":
        return "";
      case "2":
        return !logic.logicData.isVerifying && logic.step === 2
          ? "请重新认证"
          : "";
      default:
        return "";
    }
  }, [logic.step, logic.logicData.isVerifying]);

  const onSubmit = () => {
    switch (`${logic.step}`) {
      case "0":
        return logic.onNext();
      case "1":
        return "";
      case "2":
        return logic.onReCertify();
      default:
        return "";
    }
  };

  return (
    <SubLayout
      title={"实名认证"}
      footer={
        submitText ? (
          <Button className={"common-submit-button"} onClick={() => {onSubmit()}}>
            {submitText}
          </Button>
        ) : null
      }
    >
      <div className={styles.wrapper}>
        <CentifySteps step={logic.step} steps={logic.steps}/>

        <section className={styles.content}>
          <Form form={logic.form} className={styles.form}>
            <div
              style={{ display: `${logic.step}` === "0" ? "block" : "none" }}
            >
              <IdCardForm />
            </div>
            {logic.step === 1 ? (
              <FaceVideo code={logic.code} upload={logic.readVideo} />
            ) : null}
          </Form>

          {logic.step === 2 ? (
            <CentifyResult
              approvalErr={logic.auditRealNameStatus === 2}
              approvaling={logic.isVerifying}
            />
          ) : null}
        </section>
      </div>
    </SubLayout>
  );
}
